import React, { useState } from 'react';
import FormBuilderPage from './FormBuilderPage';
import FormSubmissionViewer from './FormSubmissionViewer';
import '../styles/theme.css';

const AdminEvaluationCenter = ({ userType, userData }) => {
  const [activeTab, setActiveTab] = useState('overview');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'form-builder':
        return <FormBuilderPage />;
      case 'view-submissions':
        return <FormSubmissionViewer />;
      case 'overview':
      default:
        return (
          <div className="evaluation-overview">
            <div className="overview-stats">
              <div className="stat-card">
                <h3>Active Evaluation Forms</h3>
                <p className="stat-number">-</p>
                <p className="stat-description">Forms currently available</p>
              </div>
              <div className="stat-card">
                <h3>Total Submissions</h3>
                <p className="stat-number">-</p>
                <p className="stat-description">Evaluations received</p>
              </div>
              <div className="stat-card">
                <h3>Pending Reviews</h3>
                <p className="stat-number">-</p>
                <p className="stat-description">Awaiting review</p>
              </div>
            </div>
            <div className="quick-actions">
              <h3>Quick Actions</h3>
              <div className="action-buttons">
                <button 
                  className="modern-button primary"
                  onClick={() => setActiveTab('form-builder')}
                >
                  Create New Form
                </button>
                <button 
                  className="modern-button secondary"
                  onClick={() => setActiveTab('view-submissions')}
                >
                  View Submissions
                </button>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="universal-white-container">
      <div className="evaluation-center-container">
        <div className="page-header">
          <h1 className="page-title">Admin Evaluation Center</h1>
          <p className="page-subtitle">Manage evaluation forms and review submissions</p>
        </div>
        
        <div className="tab-navigation">
          <button 
            className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            Overview
          </button>
          <button 
            className={`tab-button ${activeTab === 'form-builder' ? 'active' : ''}`}
            onClick={() => setActiveTab('form-builder')}
          >
            Form Builder
          </button>
          <button 
            className={`tab-button ${activeTab === 'view-submissions' ? 'active' : ''}`}
            onClick={() => setActiveTab('view-submissions')}
          >
            View Submissions
          </button>
        </div>
        
        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default AdminEvaluationCenter;
